export * from './virtualbeams-virtual-slides.module';
export * from './components/virtualbeams-virtual-slides.component';
